module.exports = __webpack_public_path__ + "static/media/B_F01.8ec57bea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_F01.png
// module id = 63
// module chunks = 0